import { useEffect, useRef } from 'react';
export var useSmoothScroll = function useSmoothScroll(scrollValue, setScrollValue) {
  var animationRef = useRef(0);
  var lastUpdateTime = 0;
  var smoothScrollTo = function smoothScrollTo(targetScrollLeft) {
    var duration = 300; // Animation duration in milliseconds
    var start = scrollValue; // Initial scroll position
    var change = targetScrollLeft - start; // Total distance to scroll
    var startTime = performance.now(); // Starting time of the animation

    var easeInOutQuad = function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }; // Easing function for smooth scroll

    var animateScroll = function animateScroll(currentTime) {
      var elapsed = currentTime - startTime; // Time elapsed since the animation started
      var progress = Math.min(elapsed / duration, 1); // Progress fraction (clamped to 1)
      var easedProgress = easeInOutQuad(progress); // Apply easing function

      var nextScrollLeft = start + change * easedProgress; // Compute next scroll position

      var now = performance.now();
      if (now - lastUpdateTime > 16) {
        // Update at most 60 fps
        setScrollValue(nextScrollLeft);
        lastUpdateTime = now;
      }
      if (progress < 1) {
        // If the animation isn't complete, schedule the next frame
        animationRef.current = requestAnimationFrame(animateScroll);
      } else {
        // Clean up when the animation completes
        cancelAnimationFrame(animationRef.current);
      }
    };
    // Cancel any ongoing animation
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }
    animationRef.current = requestAnimationFrame(animateScroll);
  };
  useEffect(function () {
    return function () {
      cancelAnimationFrame(animationRef.current);
    };
  }, []);
  return {
    smoothScrollTo: smoothScrollTo
  };
};